export default function VitessDiagram() {
  return (
    <>
      <pre className='inline-block bg-primary text-[12px] leading-[1rem] sm:hidden'>{`
   ┌────────────────────────────────┐   
   │░░░░░░░░░░░░░VTGate░░░░░░░░░░░░░│   
   └────────────────────────────────┘   
                    │                   
                                        
          ─ ─ ─ ─ ─ ┴ ─ ─ ─ ─ ┐         
         │                              
                              │         
         ▼                    ▼         
   ╔═══════════╗        ╔═══════════╗   
   ║           ║        ║           ║   
   ║  Primary  ║        ║  Primary  ║   
   ║           ║        ║           ║   
   ╚═══════════╝        ╚═══════════╝   
         │                    │         
                                        
     ─ ─ ┴ ─ ─            ─ ─ ┴ ─ ─     
    │         │          │         │    
    ▼         ▼          ▼         ▼    
┌───────┐ ┌───────┐  ┌───────┐ ┌───────┐
│Replica│ │Replica│  │Replica│ │Replica│
└───────┘ └───────┘  └───────┘ └───────┘
`}</pre>
      <pre className='hidden bg-primary text-[12px] leading-[1rem] sm:inline-block md:hidden lg:text-base lg:leading-[1.25rem]'>{`
           ┌──────────────────────────────────┐            
           │░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░│            
           │░░░░░░░░░░░░░░VTGate░░░░░░░░░░░░░░│            
           │░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░│            
           └──────────────────────────────────┘            
                             │                             
                                                           
         ┌ ─ ─ ─ ─ ─ ─ ─ ─ ─ ┼ ─ ─ ─ ─ ─ ─ ─ ─ ─ ┐         
                                                           
         │                   │                   │         
         ▼                   ▼                   ▼         
   ╔═══════════╗       ╔═══════════╗       ╔═══════════╗   
   ║           ║       ║           ║       ║           ║   
   ║  Primary  ║       ║  Primary  ║       ║  Primary  ║   
   ║           ║       ║           ║       ║           ║   
   ╚═══════════╝       ╚═══════════╝       ╚═══════════╝   
         │                   │                   │         
                                                           
     ─ ─ ┴ ─ ─           ─ ─ ┴ ─ ─           ─ ─ ┴ ─ ─     
    │         │         │         │         │         │    
    ▼         ▼         ▼         ▼         ▼         ▼    
┌───────┐ ┌───────┐ ┌───────┐ ┌───────┐ ┌───────┐ ┌───────┐
│Replica│ │Replica│ │Replica│ │Replica│ │Replica│ │Replica│
└───────┘ └───────┘ └───────┘ └───────┘ └───────┘ └───────┘
`}</pre>
      <pre className='hidden bg-primary text-[12px] leading-[1rem] md:inline-block lg:text-base lg:leading-[1.25rem]'>{`
               ┌─────────────────────────────────────────────────────────┐               
               │░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░│               
               │░░░░░░░░░░░░░░░░░░░░░░░░░VTGate░░░░░░░░░░░░░░░░░░░░░░░░░░│               
               │░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░│               
               └─────────────────────────────────────────────────────────┘               
                                            │                                            
                                                                                         
              ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ┼ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─              
             │                                                             │             
             ▼                              ▼                              ▼             
   ╔═══════════════════╗          ╔═══════════════════╗          ╔═══════════════════╗   
   ║                   ║          ║                   ║          ║                   ║   
   ║                   ║          ║                   ║          ║                   ║   
   ║      Primary      ║          ║      Primary      ║          ║      Primary      ║   
   ║                   ║          ║                   ║          ║                   ║   
   ║                   ║          ║                   ║          ║                   ║   
   ╚═══════════════════╝          ╚═══════════════════╝          ╚═══════════════════╝   
             │                              │                              │             
      ┌ ─ ─ ─ ─ ─ ─ ┐                ┌ ─ ─ ─ ─ ─ ─ ┐                ┌ ─ ─ ─ ─ ─ ─ ┐      
      ▼             ▼                ▼             ▼                ▼             ▼      
┌───────────┐ ┌───────────┐    ┌───────────┐ ┌───────────┐    ┌───────────┐ ┌───────────┐
│           │ │           │    │           │ │           │    │           │ │           │
│  Replica  │ │  Replica  │    │  Replica  │ │  Replica  │    │  Replica  │ │  Replica  │
│           │ │           │    │           │ │           │    │           │ │           │
└───────────┘ └───────────┘    └───────────┘ └───────────┘    └───────────┘ └───────────┘
`}</pre>
    </>
  )
}
